<div class="cleaning-device">
  <mat-form-field class="type" [matTooltip]="showQuestionIdTooltips ? detail.idType : ''">
    <mat-label>{{ 'ORDER_DETAIL.HYGIENE_INSPECTION.QUESTIONNAIRE.TYPE' | translate }}</mat-label>
    <input matInput type="text" hpmAreaChangeListener [(ngModel)]="detail.type" [disabled]="hygieneInspectionDisabled"/>
  </mat-form-field>

  <mat-form-field class="company" [matTooltip]="showQuestionIdTooltips ? detail.idCompany : ''">
    <mat-label>{{ 'ORDER_DETAIL.HYGIENE_INSPECTION.QUESTIONNAIRE.COMPANY' | translate }}</mat-label>
    <input matInput type="text" hpmAreaChangeListener [(ngModel)]="detail.company" [disabled]="hygieneInspectionDisabled"/>
  </mat-form-field>
</div>


